/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Fast_Dove_SoarInputs */

const en_gold_fast_dove_soar = /** @type {(inputs: Gold_Fast_Dove_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No timezone found`)
};

const de_gold_fast_dove_soar = /** @type {(inputs: Gold_Fast_Dove_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Zeitzone gefunden`)
};

/**
* | output |
* | --- |
* | "No timezone found" |
*
* @param {Gold_Fast_Dove_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_fast_dove_soar = /** @type {((inputs?: Gold_Fast_Dove_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Fast_Dove_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_fast_dove_soar(inputs)
	return de_gold_fast_dove_soar(inputs)
});